import currency from 'currency.js'

export const TOTAL_DOTTED_STEPS = 3
export const GIFT_AMOUNT_OTHER = 'other'
export const gitAmountOptions = ['1500', '2500', '5000']

export const STEPS = Object.freeze({
  GIFT_DETAILS: 0,
  GIFT_RECIPIENTS: 1,
  GIFT_ADD_PAYMENT: 2,
  GIFT_PAYMENT: 3,
  COMPLETE: 4,
})

export const getStepDetails = (currentStep, hasPaymentMethod, numOfRecipients) => {
  switch (currentStep) {
    case STEPS.GIFT_DETAILS:
      return {
        step: 1,
        title: 'Gift details',
        nextStep: STEPS.GIFT_RECIPIENTS,
        previousStep: undefined,
      }
    case STEPS.GIFT_RECIPIENTS:
      return {
        step: 2,
        title: `Gift recipients (${numOfRecipients})`,
        nextStep: hasPaymentMethod ? STEPS.GIFT_PAYMENT : STEPS.GIFT_ADD_PAYMENT,
        previousStep: STEPS.GIFT_DETAILS,
      }
    case STEPS.GIFT_ADD_PAYMENT:
      return {
        step: undefined,
        title: 'Add payment method',
        nextStep: STEPS.GIFT_PAYMENT,
        previousStep: STEPS.GIFT_RECIPIENTS,
      }
    case STEPS.GIFT_PAYMENT:
      return {
        step: 3,
        title: 'Payment details',
        nextStep: STEPS.COMPLETE,
        previousStep: hasPaymentMethod ? STEPS.GIFT_RECIPIENTS : STEPS.GIFT_ADD_PAYMENT,
      }
    default:
      return {}
  }
}

export const isDottedStep = currentStep => currentStep !== STEPS.GIFT_ADD_PAYMENT

export const getAmountPer = (amount, otherAmount) =>
  amount !== GIFT_AMOUNT_OTHER ? Number(amount) : formatDollarsToCents(otherAmount)

export const formatCentsToPrettyDollars = cents => {
  if (!cents) {
    return ''
  }

  return currency(Number(cents), { formatWithSymbol: true })
    .divide(100)
    .format()
}

export const formatDollarsToCents = dollars => {
  if (!dollars) {
    return ''
  }

  return currency(Number(dollars)).intValue
}
